export enum ITEM_STATUS_TYPE {
  Available = 43,
  Donated = 44,
  // CanvusProductHoldOverStage = 45
}

export enum ITEM_TYPE_ENUM {
  //Bench = 17,
  //Tree = 18,
  //Planter = 19,
  ['Public Art'] = 20,
  //Gazebo = 21,
  //Building = 22,
  //['Recognition Wall'] = 23,
  //Banner = 24,
  ['Historical Marker'] = 25,
  ['Monetary Gift'] = 26,
  //Exhibit = 27,
  //Fountain = 28,
  //['Recreation Space'] = 29,
  //Brick = 30,
  //Trail = 31,
  //Pavilion = 32,
  //['Scenic Overlook'] = 33,
  //['Covered Bridge'] = 34,
  //['Take A Book'] = 35,
  //['Bird Feeder'] = 36,
  //['Picnic Table'] = 37,
  //['Veterans Memorial'] = 38,
  ['Volunteer Activity'] = 39,
  Other = 40,
  Sponsorship = 154,
  ['Memorial Item'] = 155,
  ['Point of Interest'] = 156,
  Honoree = 157,
  Person = 158,
  Registration = 159,
  Event = 160,
}

export enum POST_ITEM_TYPE {
  Private = 'private',
  Public = 'public',
}

export const POST_ITEM_SUBHEADINGS = {
  Private: 'Only visible to Admins.',
  Public: 'Visible to anyone and ready for participation.',
} as const;


export enum ITEM_DISPLAY_VIEW {
  Both = 55,
  MapView = 56,
  GalleryView = 57
}

export enum ParticipationMethodEnum
{
    StripePayment = 134,
    StandartInterestForm = 135,
    CustomForm = 136,
}

export enum PaymentMethodEnum{
  ['Cash']= 150,
  ['Check']= 151,
  ['Credit/Debit Card']= 53,
  ['ACH Bank Transfer']= 54,
 
}
export enum DonationSourceEnum
{
    ['Manually Recorded'] = 152,
    ['SML Payment'] = 153,
}

export enum ActivityTypeEnum
{ 
    ['Interest Form'] = 95,
    ['Volunteer Form'] = 96,
    ['Payment Transaction'] = 97,
    ['New Donation Proposal'] = 98,
}